











































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
const cssPrefix = 'printProductDetails';
@Component({
  components: {
    ...UUIFComponent,
  },
})
export default class PrintProductDetailsSection extends SwExtendedVue {
  @Prop()
  printProductDetails: any;
  @Prop()
  getAssochint: any;
  @Prop()
  todoList: any;
  cssPrefix = cssPrefix;
  get selectedProduct() {
    return this.printProductDetails;
  }
  get isHesDetails() {
    if (this.selectedProduct.productExtendedInfo !== undefined) {
      const value = this.selectedProduct.productExtendedInfo[0] &&
        this.selectedProduct.productExtendedInfo[0].hesEmailAddr &&
        this.selectedProduct.productExtendedInfo[0].hesEmailAddr.length > 0;
      return this.selectedProduct.isHESSku && value;
    }
    return false;
  }
  switchToClassic() {
    const sessionId = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const url = `${window.location.origin}/user/productgroup.aspx?I=${btoa(sessionId)}`;
    window.open(url, '_blank');
  }
}
